import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  RiSearchLine,
  RiEditLine,
  RiDeleteBin6Line,
  RiAddLine,
  RiPhoneLine,
  RiMapPinLine,
  RiHospitalLine,
  RiUserStarLine,
} from "react-icons/ri";
import axios from "axios";
import "./HospitalManage.css"; // Import the new CSS file
import HospitalModal from "./HospitalModal";

const HospitalManagement = () => {
  const [hospitals, setHospitals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedHospital, setSelectedHospital] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    fetchHospitals();
  }, []);

  const fetchHospitals = async () => {
    try {
      const response = await axios.get(
        "https://api.swasthmitra.com/api/hospital/gethospital"
      );
      setHospitals(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching hospitals:", error);
      setLoading(false);
      setMessage({
        type: "error",
        text: error.response?.data?.message || "Error fetching hospitals",
      });
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this hospital?")) {
      try {
        await axios.delete(
          `https://api.swasthmitra.com/api/hospital/deletehospital/${id}`
        );
        setMessage({ type: "success", text: "Hospital deleted successfully" });
        fetchHospitals();
      } catch (error) {
        console.error("Error deleting hospital:", error);
        setMessage({
          type: "error",
          text: error.response?.data?.message || "Error deleting hospital",
        });
      }
    }
  };

  const filteredHospitals = hospitals?.filter(
    (hospital) =>
      hospital.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      hospital.address.toLowerCase().includes(searchTerm.toLowerCase()) ||
      hospital.phoneNumber.includes(searchTerm) ||
      hospital.hospitalSpecialization.some((spec) =>
        spec.toLowerCase().includes(searchTerm.toLowerCase())
      )
  );

  return (
    <div className="store-management">
      <div className="header">
        <h2>Hospital Management</h2>
        <div className="actions">
          <div className="search-box">
            <RiSearchLine />
            <input
              type="text"
              placeholder="Search hospitals..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          {/* <button
                        className="add-btn"
                        onClick={() => {
                            setSelectedHospital(null);
                            setIsEditing(false);
                            setShowModal(true);
                        }}
                    >
                        <RiAddLine /> Add Hospital
                    </button> */}
        </div>
      </div>

      {message && (
        <div className={`message ${message.type}`}>{message.text}</div>
      )}

      {loading ? (
        <div className="loading">Loading hospitals...</div>
      ) : (
        <div className="stores-grid">
          {filteredHospitals?.map((hospital) => (
            <motion.div
              key={hospital._id}
              className="store-card"
              whileHover={{ scale: 1.02 }}
            >
              {hospital.hospitalImage && (
                <div className="hospital-image">
                  <img src={hospital.hospitalImage} alt={hospital.name} />
                </div>
              )}
              <div className="store-info">
                <h3>
                  <RiHospitalLine /> {hospital.name}
                </h3>
                <p className="address">
                  <RiMapPinLine /> {hospital.address}
                </p>
                <p className="phone">
                  <RiPhoneLine /> {hospital.phoneNumber}
                </p>
                <p className="specialization">
                  <RiUserStarLine /> Specializations:{" "}
                  {hospital.hospitalSpecialization.join(", ")}
                </p>
                <p className="doctors-count">
                  👨‍⚕️ Doctors: {hospital.doctors?.length || 0}
                </p>
              </div>

              {hospital.mapIframe && (
                <div className="store-map">
                  <div
                    dangerouslySetInnerHTML={{ __html: hospital.mapIframe }}
                  />
                </div>
              )}

              <div className="card-actions">
                <button
                  className="edit-btn"
                  onClick={() => {
                    setSelectedHospital(hospital);
                    setIsEditing(true);
                    setShowModal(true);
                  }}
                >
                  <RiEditLine /> Edit
                </button>
                <button
                  className="delete-btn"
                  onClick={() => handleDelete(hospital._id)}
                >
                  <RiDeleteBin6Line /> Delete
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      )}

      <AnimatePresence>
        {showModal && (
          <HospitalModal
            hospital={selectedHospital}
            isEditing={isEditing}
            onClose={() => {
              setShowModal(false);
              setSelectedHospital(null);
            }}
            onSave={() => {
              fetchHospitals();
              setShowModal(false);
            }}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default HospitalManagement;
